import { CreateBillingAccount } from "@/components/forms/CreateBillingAccount.tsx";
import { MaskIcon } from "@/components/icon/MaskIcon.tsx";
import { CurrencyBalance } from "@/components/l10n/Currency.tsx";
import { AddPaymentMethodButton, TopUpNowButton } from "@/modules/billing/ActionButtons.tsx";
import { billingStateAtom } from "@/modules/billing/billingLogic.tsx";
import { useSuspenseQueryAtom } from "@/utils/query/useSuspenseQueryAtom.ts";
import { Trans } from "@lingui/react/macro";
import { exhaustiveSwitchCheck } from "@warrenio/utils/unreachable";

export default function PaymentTopItem() {
    const { defaultAccount, callToAction } = useSuspenseQueryAtom(billingStateAtom);

    // NB: We currently only show actions for the default account here (no explicit reason though)
    if (defaultAccount) {
        const { remainingCredit } = defaultAccount;

        return (
            <>
                {remainingCredit != null && (
                    <div className="whitespace-nowrap inline-flex items-center text-success pr-2">
                        <MaskIcon className="jp-card-icon size-0.75rem mr-1" />
                        <Trans>
                            Remaining credit <CurrencyBalance value={remainingCredit} />
                        </Trans>
                    </div>
                )}

                {(() => {
                    const { nextAction } = defaultAccount;
                    switch (nextAction) {
                        case "must_top_up":
                        case "top_up":
                            return <TopUpNowButton variant="ghost" size="bar" account={defaultAccount} />;
                        case "wait_for_verification":
                        case "add_payment_method":
                            return <AddPaymentMethodButton variant="ghost" size="bar" account={defaultAccount} />;
                        case "contact_support":
                        case "pending":
                            return null;
                        case null:
                            return null;
                        default:
                            exhaustiveSwitchCheck(nextAction);
                    }
                })()}
            </>
        );
    }

    if (callToAction.action === "create_account") {
        return <CreateBillingAccount wording="long" color="success" variant="ghost" size="bar" icon="jp-card-icon" />;
    }

    return null;
}
